import { render, staticRenderFns } from "./UpdateCardModal.vue?vue&type=template&id=d45f9d44&scoped=true&"
import script from "./UpdateCardModal.vue?vue&type=script&lang=js&"
export * from "./UpdateCardModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateCardModal.vue?vue&type=style&index=0&id=d45f9d44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45f9d44",
  null
  
)

export default component.exports